module.exports = __webpack_public_path__ + "91935999f5ab23ab491d854b1e8fa423.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/frilly-flower-pink.png
// module id = 2199
// module chunks = 0